export const columns = [
  { key: "ord", name: "序号", fixed: true, point: 0, width: 150 },
  { key: "appName", name: "产品名称", point: 0, width: 150, fixed: true },
  { key: "osType", name: "平台", point: 0, fixed: true },
  { key: "lineCharts", name: "30日新增曲线", width: 150, point: 0 },
  {
    key: "totalIncre",
    name: "总新增",
    width: 120,
    sort: true,
    point: 0,
    type: "number",
  },
  {
    key: "allTotalIncome",
    name: "收入总计",
    unit: "$",
    point: 2,
    width: 120,
    sort: true,
  },
  {
    key: "popTotalUSD",
    name: "推广总计",
    unit: "$",
    point: 2,
    width: 120,
    sort: true,
  },
  {
    key: "popuIncre",
    name: "推广新增",
    width: 120,
    point: 0,
    sort: true,
  },
  {
    key: "orgIncre",
    name: "自然新增",
    point: 0,
    width: 120,
    sort: true,
  },
  {
    key: "orgPercent",
    name: "自然量占比",
    point: 2,
    width: 140,
    sort: true,
    percent: "%",
    tip: "自然新增/总新增",
  },
  {
    key: "activeUser",
    name: "活跃用户",
    point: 0,
    width: 120,
    sort: true,
  },
  {
    key: "activePecent",
    name: "活跃新增比",
    point: 0,
    width: 140,
    sort: true,
  },
  {
    key: "cresCost",
    name: "新增单价",
    unit: "$",
    point: 2,
    width: 120,
    sort: true,
    tip: "支出总计/总新增",
  },
  {
    key: "popCost",
    name: "推广单价",
    unit: "$",
    point: 0,
    width: 120,
    sort: true,
    tip: "支出总计/推广新增",
  },
  {
    key: "arpu",
    name: "变现活跃ARPU",
    unit: "$",
    point: 3,
    width: 170,
    sort: true,
    tip: "变现收入/活跃用户",
  },

  {
    key: "increRoi",
    name: "新增ROI",
    point: 2,
    width: 120,
    percent: "%",
    sort: true,
    tip: "预估倍数/新增单价",
  },
  {
    key: "toDayROI",
    name: "当日ROI",
    point: 2,
    width: 120,
    percent: "%",
    sort: true,
    tip: "推广总计/收入总计",
  },
  {
    key: "roiTotal",
    name: "总ROI",
    point: 2,
    width: 120,
    percent: "%",
    sort: true,
    tip: "（累计 ）收入/支出 ，以一个固定值形式呈现",
  },
  {
    key: "retenRate1",
    name: "1留",
    sort: true,
    width: 120,
    point: 2,
    percent: "%",
  },
  {
    key: "retenRate3",
    name: "3留",
    point: 2,
    width: 120,
    sort: true,
    percent: "%",
  },
  {
    key: "retenRate7",
    name: "7留",
    sort: true,
    width: 120,
    percent: "%",
  },
  {
    key: "retenRate14",
    name: "14留",
    width: 120,
    percent: "%",
    sort: true,
  },
  {
    key: "retenRate30",
    name: "30留",
    percent: "%",
    width: 120,
    sort: true,
  },
  {
    key: "payPerAdsRate",
    name: "内购收入占比",
    point: 2,
    width: 140,
    sort: true,
    percent: "%",
  },
];
export const osTypeFu = (num) => {
  switch (num) {
    case 1:
      return "android";
    case 2:
      return "google";
    case 3:
      return "ios";
    default:
      return "-";
  }
};